"use client";

import { useState, useEffect } from "react";
import { getInstance, type AuthState } from "@opencampus/ochub-utils";

interface UseOCAccountReturn {
  isAuthenticated: boolean;
  ocId: string | undefined;
  ethAddress: string | undefined;
  authState: AuthState;
  isInitialized: boolean;
}

export function useOCAccount(): UseOCAccountReturn {
  const [authState, setAuthState] = useState<AuthState>({});
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Only run on client side
    if (typeof window === "undefined") return;

    try {
      const account = getInstance({ sandboxMode: true });

      // Get initial state
      setAuthState(account.getAuthState());
      setIsInitialized(account.isSDKInitialized());

      // Subscribe to auth state changes
      const unsubscribe = account.subscribe((newState) => {
        setAuthState(newState);
        setIsInitialized(account.isSDKInitialized());
      });

      return () => {
        unsubscribe();
      };
    } catch (error) {
      console.error("Failed to initialize OCAccount:", error);
    }
  }, []);

  return {
    isAuthenticated: !!authState.OCId,
    ocId: authState.OCId,
    ethAddress: authState.ethAddress,
    authState,
    isInitialized,
  };
}
